<template lang='pug'>
    #purchase-tax-document-list
        r-table(
            no-data-text='Sin documentos de compra.'
            no-remove
            ref='table'
            remind-key='purchase-tax-document-list'
            v-bind='tableProps'
            @detail='submitDetail'
        )
            template( slot='actions' slot-scope='props' )
                r-btn-action(
                    color='info'
                    :disabled='!!props.item.accounting_date'
                    tooltip='Fecha contable'
                    @click='submitAccountingDate( props )'
                )
                    v-icon update

        // CREDIT DETAIL
        r-dialog(
            no-confirm
            :title='"Nota de crédito #" + selected.id'
            v-model='dialogs.credit'
        )
            r-form(
                ref='creditForm'
                v-bind='creditProps'
                v-model='selected'
                
            )

        // DEBIT DETAIL
        r-dialog(
            no-confirm
            :title='"Nota de debito #" + selected.id'
            v-model='dialogs.debit'
        )
            r-form(
                ref='debitForm'
                v-bind='debitProps'
                v-model='selected'
                @submit="debitUpdate"
            )

        // INVOICE DETAIL
        r-dialog(
            no-confirm
            :title='"Factura de compra #" + selected.id'
            v-model='dialogs.invoice'
        )
            r-form(
                ref='invoiceForm'
                v-bind='invoiceProps'
                v-model='selected'
                @submit="invoiceUpdate"
            )

        // ACCOUNTING DATE
        v-dialog( width='800' v-model='dialogs.accounting' )
            r-form( 
                submit-text='establecer'
                title='establecer fecha contable'
                v-bind='accountingProps'
                v-model='selected'
                @submit='onAccounting'
                )
</template>

<script>
    //
    import moment from 'moment'
    import { mapActions, mapState } from 'vuex'
    import { RBtnAction, RDialog, RForm, RTable } from '@/components/reusable_components/next'
    //
    import PurchaseCreditNoteModel from '@/models/Purchase/PchPurchaseCreditNote'
    import PurchaseDebitNoteModel from '@/models/Purchase/PchPurchaseDebitNote'
    import PurchaseInvoiceModel from '@/models/Purchase/PchPurchaseInvoice'
    import PurchaseSaleBookModel from '@/models/Accounting/AccPurchaseSaleBook'
    import TaxDocumentModel from '@/models/Purchase/PchTaxDocument'
    //
    import TaxDocumentFilters from '@/views/Purchase/PchTaxDocument/PchTaxDocumentFilters'
    import TaxDocumentHeaders from '@/views/Purchase/PchTaxDocument/PchTaxDocumentHeaders'
    //
    import PurchaseCreditNoteFields from '@/views/Purchase/PchPurchaseCreditNote/PchPurchaseCreditNoteFields'
    import PurchaseDebitNoteFields from '@/views/Purchase/PchPurchaseDebitNote/PchPurchaseDebitNoteFields'
    import PurchaseInvoiceFields from '@/views/Purchase/PchPurchaseInvoice/PchPurchaseInvoiceFields'
    //
    /* services */
    import PurchaseInvoiceService from '@/services/api/purchaseInvoice/'
    import PurchaseDebitNoteService from '@/services/api/purchaseDebit/'
    //
    import PchTaxDocumentFields from '@/views/Purchase/PchTaxDocument/fields'
    //
    export default {
        components: {
            RBtnAction,
            RDialog,
            RForm,
            RTable,
        },
        computed: {

            //
            ...mapState('SnackbarModalModule', [
                'responseConfirm',
            ]),

            /**
             * { function_description }
             *
             * @return     {Object}  { description_of_the_return_value }
             */
            creditParams() {
                return {
                    document_type_title: this.selected.document_type ? 'Documento: Nota de debito' : 'Documento: Factura de compra',
                    pch_provider_branch_offices: this.selected.pch_provider_branch_offices,
                    pch_provider_trigger: this.triggerProvider,
                }
            },

            /**
             *
             */
            creditProps () {
                return {
                    editable: false,
                    fields: PurchaseCreditNoteFields(this.creditParams).variant(this.selected.document_type),
                    loading: this.busy,
                }
            },

            /**
             * { function_description }
             *
             * @return     {Object}  { description_of_the_return_value }
             */
            debitParams() {
                return {
                    document_type_title: this.selected.document_type ? 'Documento: Nota de debito' : 'Documento: Factura de compra',
                    pch_provider_branch_offices: this.selected.pch_provider_branch_offices,
                    pch_provider_trigger: this.triggerProvider,
                }
            },

            /**
             *
             */
            debitProps () {
                return {
                    editable: false,
                    switchEdit:true,
                    fields: PurchaseDebitNoteFields(this.debitParams).variant(this.selected.document_type),
                }
            },

            /**
             *
             */
            invoiceProps () {
                return {
                    editable: false,
                    switchEdit:true,
                    fields: PurchaseInvoiceFields(this.arrProviderBranch),
                    loading: this.busy,
                }
            },

            /**
             *
             */
            tableProps () {
                return {
                    filters: TaxDocumentFilters,
                    headers: TaxDocumentHeaders,
                    mapperFilter: this.mapTableFilter,
                    service: TaxDocumentModel,
                }
            },

            /**
             * 
             */
            accountingProps() {
                return {
                    fields: PchTaxDocumentFields.toAccounting(),
                }
            },
        },
        data () {
            return {
                busy: false,
                dialogs: {
                    accounting: false,
                    credit: false,
                    debit: false,
                    invoice: false,
                },
                selected: {
                    accounting_date: '',
                },
                arrProviderBranch:[],
            }
        },
        methods: {

            //
            ...mapActions( 'MenuesModule', [
                'setItemsTopBar',
                'setTitleTopBar',
            ]),

            //
            ...mapActions('SnackbarModalModule', [
                'setErrorSnackbar',
                'setSuccessSnackbar',
                'setWarningSnackbar',
            ]),

            /**
             * Fetches a purchase credit note.
             *
             * @param      {<type>}  id      The identifier
             * @return     {<type>}  The purchase credit note.
             */
            fetchPurchaseCreditNote(id) {
                return PurchaseCreditNoteModel.modeler().find(id)
            },

            /**
             * Fetches a purchase debit note.
             *
             * @param      {<type>}  id      The identifier
             * @return     {<type>}  The purchase debit note.
             */
            fetchPurchaseDebitNote(id) {
                return PurchaseDebitNoteModel.modeler().find(id)
            },

            /**
             * Fetches a purchase invoice.
             *
             * @param      {<type>}  id      The identifier
             * @return     {<type>}  The purchase invoice.
             */
            fetchPurchaseInvoice(id) {
                return PurchaseInvoiceModel.modeler().find(id)
            },

            /**
             * { function_description }
             *
             * @param      {<type>}  val     The value
             * @return     {Object}  { description_of_the_return_value }
             */
            mapTableFilter(val) {

                //
                const hasAccountingMax = val.hasOwnProperty('accounting_date_max')
                const hasAccountingMin = val.hasOwnProperty('accounting_date_min')
                const hasAccounting    = hasAccountingMax && hasAccountingMin
                const accounting_date  = hasAccounting ? `${val.accounting_date_min},${val.accounting_date_max}` : undefined

                //
                return {
                    ...val,
                    accounting_date_max: undefined,
                    accounting_date_min: undefined,
                    accounting_date,
                    pending_debts_to_pay: val.pending_debts_to_pay ? true : undefined,
                }
            },

            /**
             * 
             */
            onAccounting() {
                // console.log({ selected: this.selected })
                
                this.toAccountingDate()
            },

            /**
             *
             */
            refresh() {
                this.$refs.table.refresh()
            },

            /**
             * Sets the purchase credit note.
             *
             * @param      {<type>}  model   The model
             */
            setPurchaseCreditNote(model) {
                this.busy = false
                this.selected = model.reset()
            },

            /**
             * Sets the purchase debit note.
             *
             * @param      {<type>}  model   The model
             */
            setPurchaseDebitNote(model) {
                this.busy = false
                this.selected = model.reset()
            },

            /**
             * Sets the purchase invoice.
             *
             * @param      {<type>}  model   The model
             */
            setPurchaseInvoice(model) {
                this.busy = false
                this.selected = model.reset()
            },

            /**
             *
             */
            submitAccountingDate( event ) {

                //
                // this.setWarningSnackbar({
                //     title: '¿Desea establecer el dia de hoy como fecha contable?',
                //     message: 'Una vez establecida la fecha contable,no se puede modificar.',
                //     confirm: 'confirmar',
                // })
                this.dialogs.accounting = true

                this.selected = event.item
            },

            /**
             * { function_description }
             *
             * @return     {<type>}  { description_of_the_return_value }
             */
            submitCreatePurchaseCreditNote() {
                return this.$router.push({ name: 'purchase-credit-note-create' })
            },

            /**
             * { function_description }
             *
             * @return     {<type>}  { description_of_the_return_value }
             */
            submitCreatePurchaseDebitNote() {
                return this.$router.push({ name: 'purchase-debit-note-create' })                
            },

            /**
             * Go to create purchase invoice
             */
            submitCreatePurchaseInvoice() {
                this.$router.push({ name: 'pch-purchase-invoice-create' })                
            },

            /**
             *
             */
            submitDetail(event) {

                // clean selected
                this.busy = true
                this.selected = {}
                this.arrProviderBranch = [event.item.pch_provider_branch_offices]
                // fetch selected credit item
                if (event.item.is_credit) {
                    this.fetchPurchaseCreditNote(event.item.id).then(this.setPurchaseCreditNote)
                }

                // fetch selected debit item
                if (event.item.is_debit) {
                    this.fetchPurchaseDebitNote(event.item.id).then(this.setPurchaseDebitNote)
                }

                // fetch selected invoice item
                if (event.item.is_invoice) {
                    this.fetchPurchaseInvoice(event.item.id).then(this.setPurchaseInvoice)
                }

                // show selected dialog
                this.dialogs.credit  = event.item.is_credit
                this.dialogs.debit   = event.item.is_debit
                this.dialogs.invoice = event.item.is_invoice
            },

            /**
             * 
             */
            successAccountingDate() {
                this.setSuccessSnackbar('Fecha contable actualizada exitosamente.')
                this.dialogs.accounting = false
            },

            /**
             *
             */
            toAccountingDate() {

                //
                var PurchaseSaleBook = new PurchaseSaleBookModel({
                    id: 'change_purchase_docs',
                    accounting_date : moment(this.selected.accounting_date).format('YYYY-MM-DD'),
                    credit_notes    : this.selected.is_credit ? [ this.selected.id ] : [],
                    debit_notes     : this.selected.is_debit ? [ this.selected.id ] : [],
                    invoices        : this.selected.is_invoice ? [ this.selected.id ] : [],
                })

                //
                return PurchaseSaleBook
                    .attach(PurchaseSaleBook.toAttach())
                    .then(this.successAccountingDate)
                    .then(this.refresh)
                    .catch(this.error)
            },

            /**
             * 
             */
            triggerProvider(ctx) {
                this.selected.pch_provider_branch_offices = ctx
                    .getInput('pch_provider_id')
                    .getSelected()
                    .getProperty('branch_offices', [])
            },
            /*
             */
            async invoiceUpdate(event) {
                const   idInvoice = event.id,
                        payable = event.payable
                //
                let response  = await PurchaseInvoiceService.payable(idInvoice, payable)
                if (response.data.status === 'success'){
                    this.setSuccessSnackbar(response.data.message)
                    this.$refs.invoiceForm.edit = false
                }
                else{
                    this.setErrorSnackbar('Error al Actualizar')
                }
                //
            },
            /*
             */
            async debitUpdate(event){
                const   idDebitNote = event.id,
                        payable = event.payable
                //
                let response  = await PurchaseDebitNoteService.payable(idDebitNote, payable)
                if (response.data.status === 'success'){
                    this.setSuccessSnackbar(response.data.message)
                    this.$refs.debitForm.edit = false
                }
                else{
                    this.setErrorSnackbar('Error al Actualizar')
                }
                //
            }
        },
        watch: {

            /**
             * 
             */
            responseConfirm(val) {
                switch(val) {
                    case 'confirmar': return this.toAccountingDate()
                }
            }
        },
        beforeMount () {
            this.setTitleTopBar('Documentos de compra')
        },
        mounted() {
            this.setItemsTopBar([
                {
                    text: 'crear factura de compra',
                    icon: 'add_circle',
                    action: this.submitCreatePurchaseInvoice,
                },
                {
                    text: 'crear nota de credito',
                    icon: 'add_circle',
                    action: this.submitCreatePurchaseCreditNote,
                },
                {
                    text: 'crear nota de debito',
                    icon: 'add_circle',
                    action: this.submitCreatePurchaseDebitNote,
                },                
            ])
        }
    }
</script>